import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image
} from '@react-pdf/renderer';

// styles
const styles = StyleSheet.create({
  page: {
    fontFamily: 'PT sans',
    backgroundColor: '#F1F1F1'
  },
  image: {
    width: '21%'
  },
  pageNumber: {
    position: 'absolute',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 12,
    bottom: 30,
    left: 35,
    right: 35,
    color: 'grey'
  },
  header: {
    margin: '10px 35px 25px 35px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  company: {
    fontWeight: 'bold',
    fontSize: 21
  },
  confid: {
    color: '#b5b7b7',
    fontSize: 15
  },
  title: {
    color: '#5A96F6',
    fontSize: 23,
    fontWeight: '900',
    textAlign: 'center',
    margin: '10px auto'
  },
  summaryContainer: {
    margin: '0 35px'
  },
  summaryHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#ACCAFA',
    padding: 10,
    borderBottom: '3px solid green'
  },
  summary: {
    backgroundColor: '#D5FCD9',
    padding: 10,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  summaryColumn: {},
  text: {
    fontSize: 11,
    margin: '1px 0'
  },
  textLink: {
    fontSize: 11,
    color: '#0463C1',
    textDecoration: 'underline'
  },
  textStrong: {
    fontSize: 10,
    color: '#0045C4',
    textTransform: 'uppercase',
    fontWeight: '800',
    margin: '1px 0'
  },
  execStratContainer: {
    margin: '15px 35px'
  },
  execStratTitle: {
    fontSize: 11,
    color: '#002365',
    textTransform: 'uppercase'
  },
  scoreContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10
  },
  score: {
    fontSize: 21,
    color: '#ACCAFA',
    margin: 3
  },
  average: {
    fontSize: 11,
    textAlign: 'center',
    color: '#767171'
  },
  commentContainer: {
    margin: '10px 35px'
  },
  commentBox: {
    minHeight: 85,
    backgroundColor: '#D5FCD9',
    padding: 7,
    marginTop: 5
  },
  opinionValContainer: {
    marginTop: 5
  },
  opinionVal: {
    fontSize: 17,
    color: '#ACCAFA',
    marginTop: 3
  },
  strWeakContainer: {
    marginTop: 5,
    flexDirection: 'row'
  },
  strWeakColumn: {
    marginRight: 2,
    flex: 0.5
  },
  strHeader: {
    backgroundColor: '#ACCAFA',
    padding: 5
  },
  strValues: {
    backgroundColor: '#D5FCD9',
    padding: 5
  },
  strWeaktext: {
    fontSize: 11,
    margin: '3px 0'
  },
  strText: {
    fontSize: 11
  },
  valuationMethodContainer: {
    marginTop: 5,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  valMethod: {
    fontSize: 15,
    color: '#ACCAFA',
    marginTop: 3
  }
});

Font.register({
  family: 'PT sans',
  src: 'http://fonts.gstatic.com/s/ptsans/v8/FUDHvzEKSJww3kCxuiAo2A.ttf',
  weight: '400,500,600,700,800,900',
  style: 'italic'
});

// Document Component
const FeedbackPDF = ({
  companyLogo,
  executionStrategy,
  financialPosition,
  qualityManagement,

  opinionOnValuation,
  strengths,
  weaknesses,
  challenges,
  positiveIov,
  negativeIov,
  valuationMethodos,
  riskFactors,

  peers
}) => (
  <Document>
    <Page style={styles.page}>
      <View fixed style={styles.header}>
        <Image src={companyLogo} style={styles.image} />
        <Text style={styles.confid}>strictly confidential</Text>
      </View>
      <Text fixed style={styles.title}>
        Feedback summary
      </Text>
      <View style={styles.summaryContainer}>
        <View style={styles.summaryHeader}>
          <Text style={styles.textStrong}>Investor</Text>
          <Text style={styles.text}>Fidelity (FMR)</Text>
          <Text>FIDELITY</Text>
        </View>
        <View style={styles.summary}>
          <View style={styles.summaryColumn}>
            <Text style={styles.textStrong}>Investor type</Text>
            <Text style={styles.textStrong}>Country</Text>
            <Text style={styles.textStrong}>AuM</Text>
            <Text style={styles.textStrong}>Year of creation</Text>
            <Text style={styles.textStrong}>Website</Text>
          </View>
          <View style={styles.summaryColumn}>
            <Text style={styles.text}>Mutual fund</Text>
            <Text style={styles.text}>USA</Text>
            <Text style={styles.text}>$2,500 bn</Text>
            <Text style={styles.text}>1946</Text>
            <Text style={styles.textLink}>www.fidelity.com</Text>
          </View>
          <View style={styles.summaryColumn}>
            <Text style={styles.text}>Date of feedback</Text>
            <Text style={styles.text}>Meeting with management</Text>
            <Text style={styles.text}>Order in the book</Text>
            <Text style={styles.text}>Valuation</Text>
          </View>
          <View style={styles.summaryColumn}>
            <Text style={styles.text}>27-07-2020</Text>
            <Text style={styles.text}>14-08-2020</Text>
            <Text style={styles.text}>-</Text>
            <Text style={styles.text}>-</Text>
          </View>
        </View>
      </View>
      <View style={styles.execStratContainer}>
        <Text style={styles.execStratTitle}>Execution of strategy</Text>
        <Text style={styles.text}>
          Please rate management key strategic decisions comunication and
          execution
        </Text>
        <View style={styles.scoreContainer}>
          <Text style={styles.score}>{executionStrategy}</Text>
          <Text style={styles.text}>/ 10</Text>
        </View>
        <Text style={styles.average}>Average: 6.4</Text>
      </View>
      <View style={styles.execStratContainer}>
        <Text style={styles.execStratTitle}>Financial position</Text>
        <Text style={styles.text}>
          Please rate the current financial structure of the company with
          regards to peers and/or sector:
        </Text>
        <View style={styles.scoreContainer}>
          <Text style={styles.score}>{financialPosition}</Text>
          <Text style={styles.text}>/ 10</Text>
        </View>
        <Text style={styles.average}>Average: 5.3</Text>
      </View>
      <View style={styles.execStratContainer}>
        <Text style={styles.execStratTitle}>Quality of management</Text>
        <Text style={styles.text}>Please rate quality of management</Text>
        <View style={styles.scoreContainer}>
          <Text style={styles.score}>{qualityManagement}</Text>
          <Text style={styles.text}>/ 10</Text>
        </View>
        <Text style={styles.average}>Average: 6.2</Text>
      </View>
      <View style={styles.execStratContainer}>
        <Text style={styles.execStratTitle}>Opinion on valuation proposed</Text>
        <View style={styles.opinionValContainer}>
          <Text style={styles.opinionVal}>{opinionOnValuation}</Text>
        </View>
      </View>
      <View break style={styles.execStratContainer}>
        <Text style={styles.execStratTitle}>Strengths & weaknesses</Text>
        <View style={styles.strWeakContainer}>
          <View style={styles.strWeakColumn}>
            <View style={styles.strHeader}>
              <Text style={styles.strText}>Strengths</Text>
            </View>
            <View style={styles.strValues}>
              {strengths.length > 0 &&
                strengths.map((str) => (
                  <Text key={str.name} style={styles.strWeaktext}>
                    {str.name}
                  </Text>
                ))}
            </View>
          </View>
          <View style={styles.strWeakColumn}>
            <View style={styles.strHeader}>
              <Text style={styles.strText}>Weaknesses</Text>
            </View>
            <View style={styles.strValues}>
              {weaknesses.length > 0 &&
                weaknesses.map((wkn) => (
                  <Text key={wkn.name} style={styles.strWeaktext}>
                    {wkn.name}
                  </Text>
                ))}
            </View>
          </View>
        </View>
      </View>
      <View style={styles.commentContainer}>
        <Text style={styles.execStratTitle}>Management challenges</Text>
        <Text style={styles.text}>
          Please list the few challenges that the management of the issuer would
          be facing:
        </Text>
        <View style={styles.commentBox}>
          {challenges.length > 0 &&
            challenges.map((chlg) => (
              <Text key={chlg.name} style={styles.text}>
                {chlg.name}
              </Text>
            ))}
        </View>
      </View>
      <View style={styles.execStratContainer}>
        <Text style={styles.execStratTitle}>Influence on valuation</Text>
        <Text style={styles.text}>
          Please list key factors that could positively or negatively impact
          valuation:
        </Text>
        <View style={styles.strWeakContainer}>
          <View style={styles.strWeakColumn}>
            <View style={styles.strHeader}>
              <Text style={styles.strText}>Positively</Text>
            </View>
            <View style={styles.strValues}>
              {positiveIov.length > 0 &&
                positiveIov.map((pos) => (
                  <Text key={pos.name} style={styles.strWeaktext}>
                    {pos.name}
                  </Text>
                ))}
            </View>
          </View>
          <View style={styles.strWeakColumn}>
            <View style={styles.strHeader}>
              <Text style={styles.strText}>Negatively</Text>
            </View>
            <View style={styles.strValues}>
              {negativeIov.length > 0 &&
                negativeIov.map((neg) => (
                  <Text key={neg.name} style={styles.strWeaktext}>
                    {neg.name}
                  </Text>
                ))}
            </View>
          </View>
        </View>
      </View>
      <View break style={styles.execStratContainer}>
        <Text style={styles.execStratTitle}>Valuation methodologies</Text>
        <Text style={styles.text}>
          Select the top 3 methodologies to best evaluate the issuer:
        </Text>
        <View style={styles.valuationMethodContainer}>
          {valuationMethodos &&
            valuationMethodos.length > 0 &&
            valuationMethodos.map(({ label }) => (
              <Text key={label} style={styles.valMethod}>
                {label}
              </Text>
            ))}
        </View>
      </View>

      <View style={styles.execStratContainer}>
        <Text style={styles.execStratTitle}>Have you invested in peers</Text>
        <View style={styles.strWeakContainer}>
          <View style={styles.strWeakColumn}>
            <View style={styles.strHeader}>
              <Text style={styles.strText}>Peer</Text>
            </View>
            <View style={styles.strValues}>
              {peers.length > 0 &&
                peers.map((peer) => (
                  <Text key={peer} style={styles.strWeaktext}>
                    {peer}
                  </Text>
                ))}
            </View>
          </View>
          <View style={styles.strWeakColumn}>
            <View style={styles.strHeader}>
              <Text style={styles.strText}>Since</Text>
            </View>
            <View style={styles.strValues}>
              <Text style={styles.strWeaktext}>01-2019</Text>
              <Text style={styles.strWeaktext}>03-2015</Text>
            </View>
          </View>
        </View>
      </View>
      <View style={styles.commentContainer}>
        <Text style={styles.execStratTitle}>
          Your appreciation of the risk factors
        </Text>
        <Text style={styles.text}>
          Please list the risk factors that in your view are the most relevant:
        </Text>
        <View style={styles.commentBox}>
          {riskFactors.length > 0 &&
            riskFactors.map((rsk) => (
              <Text style={styles.text}>{rsk.name}</Text>
            ))}
        </View>
      </View>
      <View fixed style={styles.pageNumber}>
        <Text
          fixed
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
        />
        <Text>PRAEXO</Text>
      </View>
    </Page>
  </Document>
);

export default FeedbackPDF;
